/* eslint-disable camelcase */
export interface RefinanceIndexDTO {
  last_updated_date: string
  next_updated_date: string
  index: IndexDTO[]
}

export interface IndexDTO {
  week: string
  state: string
  region: string
  index_type: string
  volume: IndexDetail
  value: IndexDetail
}

export interface Index {
  week: Date
  state: string
  region: string
  index_type: string
  volume: IndexDetail
  value: IndexDetail
}

export interface IndexDetail {
  refi_index: number
  change_week: number
  change_month: number
  change_quarter: number
  change_year: number
}

export const EmptyObj: RefinanceIndexDTO = {
  last_updated_date: '',
  next_updated_date: '',
  index: [],
}

export interface GroupedIndex {
  key: string
  values: Array<Index>
}
